import IconStarFull from '@adv-mt/mt-svg-icons/lib/StarFull'
import IconStarHalf from '@adv-mt/mt-svg-icons/lib/StarHalf'
import IconStarEmpty from '@adv-mt/mt-svg-icons/lib/StartEmpty'

export const customStarIcons = {
  IconStarFilled: IconStarFull,
  IconStarHalfFilled: IconStarHalf,
  IconStarEmpty
}

export const DESIGNS = {DARK: 'dark', LIGHT: 'light'}

export const DEFAULT_EMPTY_SYMBOL = '-'

export const DEFAULT_MAX_RATINGS = 5
